export const PromotionTypeTab = Object.freeze({
  AutomaticDiscounts: 0,
  DiscountCodes: 1,
  PriceAdjustments: 2,
  Bundle: 3
})

export const PromotionStateTab = Object.freeze({
  All: 0,
  Active: 1,
  Scheduled: 2,
  Expired: 3
})

export const PromotionSortBy = Object.freeze({
  CreatedAt: 'CreatedAt',
  StartDate: 'StartDate'
})

export const PromotionType = Object.freeze({
  Automatic: 1,
  DiscountCode: 2,
  PriceAdjustment: 3,
  Bundle: 4
})

export const PromotionRuleType = Object.freeze({
  Percentage: 1,
  Amount: 2,
  Shipping: 3,
  BuyXGetY: 4,
  PriceOverride: 5
})

export const CustomerRoleToOption = Object.freeze({
  Employee: 1,
  Instructor: 2,
  Pastor: 3,
  Partner: 4
})

export const PromotionRequirementType = Object.freeze({
  None: 0,
  AmountMinimum: 1,
  QuantityMinimum: 2
})

export const PromotionAppliesToOption = Object.freeze({
  EntireOrder: 0,
  SpecificCategories: 1,
  SpecificProducts: 2,
  SpecificPublishers: 3,
  SpecificPublishersAndCategories: 4
})

export const ItemPriceToOption = Object.freeze({
  None: 0,
  ApplyToSalePrice: 1,
  ApplyToBasePrice: 2
})

export const PromotionExclusionType = Object.freeze({
  None: 0,
  ImprintDiscountCode: 1,
  PublishedDate: 2
})
